<template>
    <newForm v-bind:title='$t("slider_managment.title")' className="col-xs-12">
        <div v-bind:class="[direction ? 'k-rtl' : '' ]">
            <grid v-bind:columns="columns"
                  v-bind:reloadGrid="reloadGrid"
                  dataSourceUrl="api/slider/list"
                  v-bind:toolbar="toolbar"
                  selectable="false"
                  editable="false"
                  v-bind:hasPaging="hasPaging">
            </grid>
            <component v-show="showSliderModal"
                       :is="currentModalComponent"
                       v-bind:showSliderModal="showSliderModal"
                       v-bind:modalData="modalData">
            </component>
        </div>
    </newForm>
</template>
<script>
    import NewForm from '../forms/newform/newForm.vue';
    import Grid from "../widgets/grid/grid.vue";
    import ModalSlider from './modals/ModalSlider.vue';

    export default {
        data() {
            return {
                direction: payload.currentLocale.IsRightToLeft,
                columns: [
                    { field: "Id", menu: false, hidden: true },
                    { field: "Name", title: i18n.$t("slider_managment.name"), menu: false, hidden: false, width: "150px" },
                    {
                        field: "Level",
                        title: i18n.$t("slider_managment.image_displaying"),
                        menu: false,
                        hidden: false,
                        template: function (dataItem) {
                            return dataItem.Level == 5 ? i18n.$t("slider_managment.empty") : dataItem.Level;
                        },
                        width: "100px"
                    },
                    { field: "Id", title: i18n.$t("slider_managment.image"), template: '<img class="img-responsive" style="max-width:15%" src="File/ApplicationFileDownload?OutPut=inline&id=#= Id #" />', menu: false, hidden: false }
                ],
                toolbar: this.buildToolbarItems(),
                reloadGrid: 0,
                modalData: {},
                currentModalComponent: "",
                showSliderModal: 0,
                hasPaging: false
            }
        },
        methods: {
            buildToolbarItems() {
                let mapping = (value) => {
                    let hasSubActions = Array.isArray(value.subActions);
                    return {
                        type: hasSubActions ? "splitButton" : "button",
                        text: (value.icon) ? `<i class="${value.icon} fa-fw fa-lg"></i> ${value.text}` : value.text,
                        enable: value.enable,
                        click: value.action,
                        imageUrl: value.image,
                        menuButtons: hasSubActions ? value.subActions.map(mapping) : undefined
                    }
                };
                return this.getActions().map(mapping);
            },
            getActions() {
                return [
                    {
                        key: "AddSlider",
                        text: this.$t("news_management.add"),
                        icon: "far fa-plus-square",
                        action: (node, nodeData, selecteds) => {
                            this.modalData.isCreation = true;
                            this.currentModalComponent = "ModalSlider";
                            this.modalData.callback = () => {
                                this.reLoadeData();
                            };
                            this.showSliderModal++;
                        },
                        enable: true
                    },
                    {
                        key: "EditSlider",
                        text: this.$t("edit"),
                        icon: "far fa-edit",
                        action: (node, nodeData, selecteds) => {
                            this.modalData.id = nodeData[0].Id;
                            this.modalData.isCreation = false;
                            this.currentModalComponent = "ModalSlider";
                            this.modalData.callback = () => {
                                this.reLoadeData();
                            };
                            this.showSliderModal++;
                        },
                        enable: false
                    },
                    {
                        key: "DeleteSlider",
                        text: this.$t("remove"),
                        icon: "far fa-trash-alt",
                        action: (node, nodeData, selecteds) => {
                            let dataItem = nodeData[0];
                            var id = dataItem.Id;

                            var that = this;

                            confirm(i18n.$t("are_you_sure"), {
                                yes: function () {
                                    var url = "api/slider/delete/" + id;

                                    that.doAjaxRequest(url, {}, () => { that.reLoadeData(); }, () => { }, 'DELETE');
                                },
                                no: function () { }
                            });
                        },
                        enable: false
                    }
                ];
            },
            reLoadeData() {
                this.reloadGrid++;
            },
            doAjaxRequest(url, data, onSuccess, onFailure, method) {
                let ajaxConfig = {
                    url: url,
                    data: data,
                    dataType: "json",

                    contentType: "application/json;charset=utf-8"
                };
                if (method) {
                    ajaxConfig.method = method;
                }
                $.ajax(ajaxConfig)
                    .done((result) => {
                        if (typeof onSuccess === 'function')
                            onSuccess(result);
                    }).error((error) => {
                        if (typeof onFailure === 'function') {

                            var response = null;

                            if (error.status == 400) {
                                response = JSON.parse(error.responseText);
                                onFailure(response);
                            }
                        }
                    });
            }
        },
        components: {
            NewForm,
            Grid,
            ModalSlider
        }
    }
</script>
